import { serviceMaker, methods, api } from "@/http/index.js";

export const numberZoneList = () =>
    serviceMaker(`/numberzone`, methods.GET, api.NGB);
export const apnZoneList = () => serviceMaker(`/apnzone`, methods.GET, api.NGB);
export const operatorZoneList = () =>
    serviceMaker(`/operatorzone`, methods.GET, api.NGB);
export const icZoneList = () => serviceMaker(`/iczone`, methods.GET, api.NGB);
export const createNumberZone = () =>
    serviceMaker(`/mcodes/Impact Category`, methods.GET, api.NGB);
export const submitNumberZone = (data) =>
    serviceMaker(`/numberzone`, methods.POST, api.NGB, data);
export const editNumberZone = (id) =>
    serviceMaker(`/numberzone/${id}?template=true`, methods.GET, api.NGB);
export const updateNumberZone = (id, data) =>
    serviceMaker(`/numberzone/${id}`, methods.PUT, api.NGB, data);
export const dataByIdNumberZone = (id) =>
    serviceMaker(`/numberzone/${id}`, methods.GET, api.NGB);
export const deleteNumberElement = (id) =>
    serviceMaker(`/numberzone/${id}`, methods.DELETE, api.NGB);
export const submitApnZone = (data) =>
    serviceMaker(`/apnzone`, methods.POST, api.NGB, data);
export const editApnZone = (id) =>
    serviceMaker(`/apnzone/${id}?template=true`, methods.GET, api.NGB);
export const updateApnZone = (id, data) =>
    serviceMaker(`/apnzone/${id}`, methods.PUT, api.NGB, data);
export const dataByIdApnZone = (id) =>
    serviceMaker(`/apnzone/${id}`, methods.GET, api.NGB);
export const deleteApnElement = (id) =>
    serviceMaker(`/apnzone/${id}`, methods.DELETE, api.NGB);
export const submitOperatorZone = (data) =>
    serviceMaker(`/operatorzone`, methods.POST, api.NGB, data);
export const editOperatorZone = (id) =>
    serviceMaker(`/operatorzone/${id}?template=true`, methods.GET, api.NGB);
export const updateOperatorZone = (id, data) =>
    serviceMaker(`/operatorzone/${id}`, methods.PUT, api.NGB, data);
export const dataByIdOparetorZone = (id) =>
    serviceMaker(`/operatorzone/${id}`, methods.GET, api.NGB);
export const deleteOperatorElement = (id) =>
    serviceMaker(`/operatorzone/${id}`, methods.DELETE, api.NGB);
export const submitIcZone = (data) =>
    serviceMaker(`/iczone`, methods.POST, api.NGB, data);
export const updateIcZone = (id, data) =>
    serviceMaker(`/iczone/${id}`, methods.PUT, api.NGB, data);
export const dataByIcZone = (id) =>
    serviceMaker(`/iczone/${id}`, methods.GET, api.NGB);
export const deleteIcElement = (id) =>
    serviceMaker(`/iczone/${id}`, methods.DELETE, api.NGB);
